import MediaApi from '@packages/media/api';

export class MediaAdviserApi extends MediaApi {
    static resource = 'media/adviser';
}

export default MediaAdviserApi;
